import React from 'react'
import { useState } from 'react'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab } from '@mui/material'
import InfoBlock from '../../components/InfoBlock'
import { PRTable } from './PRTable'
import PRInputsApi from '../../../api/PRInputsApi'

export const PRTabs = ({
    prsInInbox,
    prsArchived,
    setPrsInInbox,
    setPrsArchived,
    // onAssociate,
    setSelectedCompany,
    selectedPR,
    setSelectedPR,
    onArchive,
    ...prTableProps
}) => {
    const [selectedTab, setSelectedTab] = useState('inbox')
    const handleChange = (event, newValue) => setSelectedTab(newValue)
    const prinputsApi = new PRInputsApi()

    const handleUnarchive = async (pr) => {
        pr.archived = null
        prinputsApi
            .unArchive(pr)
            .then(() => console.log(`Unarchived ${pr.url}`))
            .catch((error) => console.error(error))
        setPrsArchived([...prsArchived.toSpliced(prsArchived.indexOf(pr), 1)])
        setPrsInInbox([pr, ...prsInInbox])
    }

    const handleBlock = async (pr) => {
        await prinputsApi.block(pr)
        setPrsInInbox([...prsInInbox.toSpliced(prsInInbox.indexOf(pr), 1)])
        setPrsArchived([pr, ...prsArchived])
        // TODO: remove (archive) other PRs matching the same path
    }

    return (
        <InfoBlock title='Pressmeddelanden' loadingElement={!prsInInbox && !prsArchived}>
            <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList value={selectedTab} onChange={handleChange}>
                        <Tab label='Inbox' value='inbox' />
                        <Tab label='Arkiverade' value='archived' />
                    </TabList>
                </Box>
                <TabPanel value='inbox'>
                    <PRTable
                        prs={prsInInbox}
                        onArchive={onArchive}
                        onBlock={handleBlock}
                        // onAssociate={onAssociate}
                        {...prTableProps}
                        setSelectedCompany={setSelectedCompany}
                        selectedPR={selectedPR}
                        setSelectedPR={setSelectedPR}
                    />
                </TabPanel>
                <TabPanel value='archived'>
                    <PRTable prs={prsArchived} onUnarchive={handleUnarchive} {...prTableProps} />
                </TabPanel>
            </TabContext>
        </InfoBlock>
    )
}
